import "./Footer.scss";
import ContactForm from "../ContactForm/ContactForm";
import zunigaLogo from "../../assets/images/ZunigaLogo.svg";
import mail from "../../assets/icons/mail.svg";
import github from "../../assets/icons/github.svg";
import linkedin from "../../assets/icons/linkedin.svg";

export default function Footer() {
  return (
    <div className="footer" id="contact">
      <section className="footer__contact">
        <h2 className="contact__title">Contact Me</h2>
        <p className="contact__text">
          Go ahead and reach out if you have any questions, would like to
          request a free quote, or if you’d like to buy me a pizza!
        </p>
        <ContactForm />
      </section>
      <section className="footer__foot">
        <img
          src={zunigaLogo}
          alt="Zuniga Web Design Logo"
          className="foot__logo"
        />
        <div className="foot__socials">
          <a
            href="https://www.linkedin.com/in/zealtiel-zuniga-anaya"
            className="foot__link"
          >
            <img
              src={linkedin}
              alt="LinkedIn Logo"
              className="foot__linkedIn"
            />
          </a>
          <a href="https://github.com/ZeaZuniga" className="foot__link">
            <img src={github} alt="Github Loco" className="foot__github" />
          </a>
          <a href="mailto:zealtiel@outlook.com" className="foot__link">
            <img src={mail} alt="Mail Icon" className="foot__mail" />
          </a>
        </div>
        <p className="foot__copyright">Zuniga Web Design © Copyright 2024</p>
      </section>
    </div>
  );
}
